import Orders_Payments from "../../assets/images/sidebar/orders_&_payments.svg";

const billingModule = {
  name: "Billing",
  key: "orders_payments",
  imgSrc: Orders_Payments,
  submodules: [
    {
      name: "Billing",
      key: "orders_payments",
      defaultExpanded: false,
      features: [
        {
          key: "orders_payments_list",
          name: "Orders & Payments List",
          defaultEnabled: false,
          subFeatures: [
            {
              key: "view_orders_payments",
              name: "View Orders & Payments",
              defaultEnabled: true,
              description: "Shows order statistics and list of orders/sub-orders/invoices"
            },
            {
              key: "create_invoice",
              name: "Create Invoice",
              defaultEnabled: false,
              description: "Generate invoice for existing or new customer"
            },
            {
              key: "refund_payments",
              name: "Refund Payments",
              defaultEnabled: false,
              description: "Process refund for paid invoices (based on work completed)"
            }
          ]
        }
      ]
    }
  ]
};

export default billingModule;
